import React from 'react';
import { FadeIn } from './FadeIn';
import { XIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  return <section className="py-16 sm:py-24 px-4 bg-padel-dark" data-id="element-301">
      <div className="max-w-4xl mx-auto" data-id="element-302">
        <FadeIn data-id="element-303">
          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-12" data-id="element-304">
            ¿Cuánto vale todo esto?
          </h2>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-305">
          <FadeIn delay={0.1} data-id="element-306">
            <div className="flex items-center gap-4 bg-padel-surface p-4 sm:p-6 rounded-xl border border-padel-muted/50 opacity-70" data-id="element-307">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-308">
                <XIcon className="w-5 h-5 text-red-500" data-id="element-309" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-310">
                Podés contratar a un director técnico para que te organice el
                año. Son entre 3 y 5 horas de consultoría a precio de mercado.
                Solo para el plan anual.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-311">
            <div className="flex items-center gap-4 bg-padel-surface p-4 sm:p-6 rounded-xl border border-padel-muted/50 opacity-70" data-id="element-312">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-313">
                <XIcon className="w-5 h-5 text-red-500" data-id="element-314" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-315">
                Podés pagarle a alguien que diseñe tus plantillas de
                seguimiento. Otro par de horas.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-316">
            <div className="flex items-center gap-4 bg-padel-surface p-4 sm:p-6 rounded-xl border border-padel-muted/50 opacity-70" data-id="element-317">
              <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-318">
                <XIcon className="w-5 h-5 text-red-500" data-id="element-319" />
              </div>
              <p className="text-gray-300 text-sm sm:text-base" data-id="element-320">
                Podés contratar un consultor de negocio para que te arme el
                sistema de cobros y comunicación. Más horas. Más dinero.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-321">
            <div className="flex items-center gap-4 bg-padel-lime/10 p-5 sm:p-8 rounded-xl border border-padel-lime shadow-[0_0_20px_rgba(197,255,61,0.1)]" data-id="element-322">
              <div className="bg-padel-lime p-2 rounded-full shrink-0 text-padel-dark" data-id="element-323">
                <CheckIcon className="w-6 h-6 sm:w-8 sm:h-8" strokeWidth={3} data-id="element-324" />
              </div>
              <p className="text-white font-bold text-lg sm:text-xl" data-id="element-325">
                O podés tener todo eso resuelto, en PDF, listo para usar, por
                menos de lo que gastás en material deportivo en un mes.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}